import dayjs from "dayjs";
import { Tabs } from "antd";
import {
  formatCEP,
  formatCPF,
  formatTelefone,
  formatValueBrl,
} from "../../../../../../../../function/utilis/function";
import { CiCalendar } from "react-icons/ci";

const getValueByPath = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc?.[part], obj);
};

function JsonViewer({ data }) {

  const labelMap = {
    id: "ID",
    dataCadastro: "Data de Cadastro",
    dataCriacao: "Data de Criação",
    dataSituacao: "Data da Situação",
    usuarioCadastro: "Usuário que Cadastrou",
    "contato.nome": "Nome do Contato",
    "contato.cpf": "CPF",
    "contato.telefone": "Contato",
    "contato.email": "E-mail",
    "empresa.endereco.logradouro": "Endereço",
    "empresa.endereco.numero": "Número",
    "empresa.endereco.bairro": "Bairro",
    "empresa.endereco.ibgeMunicipio.id": "IBGE Municipio",
    "empresa.endereco.ibgeMunicipio.nome": "Nome do Municipio",
    "empresa.endereco.cidade": "Cidade",
    "empresa.endereco.uf": "UF",
    "empresa.endereco.cep": "CEP",
    valorTabela: "Valor de tabela",
    valor: "Valor",
    valorAvulso: "Valor avulso",
    valorPromocional: "Valor promocional",
    valorMensal: "Valor mensal",
    valorAssinatura: "Valor de assinatura",
    valorAdicional: "Valor adicional",
    carencia: "Carência",
    valorMulta: "Valor de multa",
    dataVencimento: "Vencimento",
    qtdRecorrencias: "Ocorrência",
    qtdDiasAntecipados: "Dias antecipados",
    dataPrimeiraFatura: "Data da 1° fatura",
    descricao: "Descrição",
    "formaPagamento.nome": "Forma de pagamento",

    "empresa.cnpj": "CNPJ",
    "empresa.nome": "Empresa",
    "empresa.nomeFantasia": "Nome fantasia",
    "empresa.capitalSocial": "Capital",
    "empresa.faturamento": "Faturamento",
    "empresa.quantidadeFuncionarios": "Funcionários",
    "empresa.valorServicoFuncionario": "Valor serviço funcionário",
    "empresa.valorProlabore": "Probabore",

    "diasAndamento": "Dias em andamento",
    "diasSituacaoPendente": "Dias em situação pendente",
    "diasSituacaoParalegal": "Dias situação com o paralegal",
    "simplesNacional": "Optante do Simples"
  };

  const ValoresBrl = [
    "valorTabela",
    "valor",
    "valorAvulso",
    "valorMensal",
    "valorPromocional",
    "valorAssinatura",
    "valorAdicional",
    "valorMulta",
  ];

  const Valores = [
    "valorTabela",
    "valor",
    "valorAvulso",
    "valorMensal",
    "valorPromocional",
    "valorAssinatura",
    "valorAdicional",
    "carencia",
    "valorMulta",
    "dataVencimento",
    "qtdRecorrencias",
    "qtdDiasAntecipados",
    "dataPrimeiraFatura",
    "formaPagamento.nome",
  ];

  const Endereco = [
    "empresa.endereco.logradouro",
    "empresa.endereco.numero",
    "empresa.endereco.bairro",
    "empresa.endereco.ibgeMunicipio.id",
    "empresa.endereco.ibgeMunicipio.nome",
    "empresa.endereco.cidade",
    "empresa.endereco.uf",
    "empresa.endereco.cep",
  ]

  const Contato = [
    "contato.nome",
    "contato.cpf",
    "contato.telefone",
    "contato.email",
  ]

  const Empresa = [
    "empresa.cnpj",
    "empresa.nome",
    "empresa.nomeFantasia",
    "empresa.capitalSocial",
    "empresa.faturamento",
    "empresa.quantidadeFuncionarios",
    "empresa.valorServicoFuncionario",
    "empresa.valorProlabore",
  ]

  const Descricao = [
    "descricao",
  ]

  const Observacao = [
    "observacao",
  ]

  const OutrasInfo = [
    "diasAndamento",
    "diasSituacaoPendente",
    "diasSituacaoParalegal",
    "simplesNacional"
  ]

  const camposForaDosTabs = ["dataCadastro", "dataCriacao", "dataSituacao"];

  const StyleDuasColunas = Valores.length > 8 || Endereco.length > 8 || Empresa.length > 8;

  const Style = {
    display: "grid",
    gridTemplateColumns: StyleDuasColunas ? "1fr 1fr" : "1fr",
    columnGap: "20px",
  };

  const formatValue = (path, value) => {
    if (
      [
        "dataCadastro",
        "dataCriacao",
        "dataSituacao",
        "dataVencimento",
        "dataPrimeiraFatura",
      ].includes(path)
    ) {
      if (value === null) return "—"; // ou apenas return null;
      if (typeof value === "number") return dayjs(value).format("DD/MM/YYYY HH:mm");
    }
    
    if (path === "contato.telefone") return formatTelefone(value);
    if (path === "contato.cpf") return formatCPF(value);
    if (path === "empresa.endereco.cep") return formatCEP(value);
    if (ValoresBrl.includes(path)) return formatValueBrl(value);

    return value;
  };

  const renderCampos = (filtros) =>
    filtros.map((path, index) => {
      const rawValue = getValueByPath(data, path);
      const label = labelMap[path] || path;
      const valor = formatValue(path, rawValue);
      const isValor = Valores.includes(path);

      return (
        <div
          key={index}
          style={{
            margin: "5px 0",
            padding: "6px",
            backgroundColor: isValor ? "#fff3b0" : "transparent",
            borderRadius: "4px",
          }}
        >
          <span style={{ fontWeight: "bold", color: "#3c3c3c"}}>{label}:</span>{" "}
          <span>
            {valor !== undefined && valor !== null ? String(valor) : "—"}
          </span>
        </div>
      );
    });

  return (
    <>
      <div style={{ marginBottom: "15px" }}>
        <CiCalendar style={{ fontSize: 26 }} />{" "}
        {renderCampos(camposForaDosTabs)}
      </div>

      <Tabs
        tabPosition="top"
        items={[
          {
            label: "Empresa",
            key: "1",
            children: <div style={Style}>{renderCampos(Empresa)}</div>,
          },
          {
            label: "Descrição",
            key: "2",
            children: <div>{renderCampos(Descricao)}</div>,
          },
          {
            label: "Valores e Vencimento",
            key: "3",
            children: <div style={Style}>{renderCampos(Valores)}</div>,
          },
          {
            label: "Contato",
            key: "4",
            children: renderCampos(Contato),
          },
          {
            label: "Endereço",
            key: "5",
            children: <div style={Style}>{renderCampos(Endereco)}</div>,
          },
          {
            label: "Observação",
            key: "6",
            children: <div>{renderCampos(Observacao)}</div>,
          },
          {
            label: "Outras informações",
            key: "7",
            children: <div>{renderCampos(OutrasInfo)}</div>,
          }
        ]}
      />
    </>
  );
}

export default JsonViewer;
